export default "__VITE_ASSET__bB9yawVY__"